/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

// Component imports
import { Typography } from 'antd';

// Constant declarations
const { Paragraph } = Typography;

const ResetSessionForm = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Paragraph className="text-center text-secondary">
        {t('After this node, the conversation will be recorded in a new session.')}
      </Paragraph>
    </Fragment>
  );
};

export default ResetSessionForm;
